export default {
  noRequisition: 'This position has no open requisitions. Add requisitions to continue.',
  requisitionDetails: 'Requisition Details',
  partTime: 'Part-time',
  fullTime: 'Full-time',
  seasonal: 'Seasonal',
  effectiveTime: 'Effective Date :',
  wages: 'Salary From Requisition : ',
  requisitionSelectwage: 'Requisition Salary: ',
  seasonalEndDate: 'End Date:',
  shifts: 'Shifts',
  contractedHours: 'Contracted Hours',
  minimum: 'Minimum',
  maximum: 'Maximum',
  guaranteedHours: 'Guaranteed Hours',
  requisitionID: 'Requisition',
  offerNotes: 'Internal Offer Notes',
  notesPlaceholder: 'Enter your internal offer notes here. These cannot be seen by the candidate.',
  selectRequisition: `Select Requisition`,
  locationAndPositionChanged: "This candidate has been sent an offer for a different position than the one they've applied for.",
  hourly: `Hourly`,
  annual: `Annual`,
  weekly: `Weekly`,
  conformAlert: {
    title: 'Warning',
    subtitle:
      'You are about to change the position this candidate is being hired for. Are you sure you want to make these changes?',
    close: 'Close',
    continue: 'Confirm',
  },
  partTimeHoursPerWeek: 'Hours/Week',
  couldNotLoadRequisition: 'Could not load requisition at moment.',
  OPEN: 'Open',
  CANCELLED: 'Cancelled',
  FILLED: 'Filled',
  PROCESSING: 'Processing',
  associatedCandidate: 'Selected Candidate',
  effectiveTimeInfo: 'AppyHere will begin recruiting for this requisition on {{requisitionActiveThresholdDays}}.',
  candidateRequisitionMatch: 'Candidate and Position Availability Overlap',
  compare: 'Comparison',
  days: 'Days',
  candidateAvailability: 'Candidate Availability',
  candidateAvailabilitiesInfo:
    "This is the intersection between the candidate's availability, and the shift needs for the requisition.",
  requisitionShifts: 'Desired Availability',
  requisitionRiskDashboard: 'Requisition Dashboard',
  requisitionInsights: 'Requisition Details',
  riskRequisitionDetailTable: {
    header: {
      requisitionId: 'Requisition ID',
      status: 'Status',
      createdUpdated: 'Created / Last Updated',
      hireBy: 'Hire By',
      locationPosition: 'Location & Position',
    },
    riskStatusText: {
      safe: 'On Track',
      atRisk: 'At Risk',
      overdue: 'Overdue',
    },
    overdueDaysText: 'Overdue by {{riskDays}} days',
    riskDaysText: '{{riskDays}} days left to hire',
  },
  requisitionByLocation: 'Requisitions By Location',
  businessRequisitionRiskStatus: {
    safe: 'On Track',
    atRisk: 'At Risk',
    overdue: 'Overdue',
  },
  requisitionCount: {
    unfilled: 'Open',
    atRisk: 'At Risk',
    overdue: 'Overdue',
    locationImpacted: 'Locations Impacted',
    positionImpacted: 'Positions Impacted',
  },
  pagination: {
    showingResult: 'Showing {{currentItemsLength}} of {{totalItemsLength}} requisitions',
  },
  backBtnText: 'Back',
  salaryOffered: 'Salary Offered To Candidate :',
  noRequisitionAvailable: 'This position has no open requisitions.',
  recruiterNote: 'Requisition Notes',
  additionalOffer: 'Additional Offer Terms',
  salaryRangeError: 'Please enter salary within the range.',
  hideSalaryInfo: `The job posting does not mention a salary.`,
  startingAtSalaryInfo: 'The job posting shows a salary starting at {{minSalary}}/ {{salaryUnit}}',
  rangeSalaryInfo: 'The job posting shows a salary range from {{minSalary}} to {{maxSalary}}/ {{salaryUnit}}',
  upToSalaryInfo: 'The job posting shows a salary upto {{maxSalary}}/ {{salaryUnit}}',
  fixedSalaryInfo: 'The job posting shows a fixed salary of {{minSalary}}/ {{salaryUnit}}',
  salaryExceptionMessage:
    'Your offer has a higher salary than the one displayed to candidates for this position (maxSalary). Offering an amount outside of what was shown to the candidate may violate local salary transparency & other compliance laws.',
  acknowledgeText: "I acknowledge this job offer's salary exceeds the displayed salary range for this position.",

  salaryFromRequisition: 'Salary:',
  requisitionNotes: 'Requisition Notes',
  shiftSchedule: 'Shift Schedule',
  candidateAndPositionAvailabilityOverlap: 'Candidate and Position Availability Overlap',
  weekdayShift: 'Weekday Shift',
  weekendShift: 'Weekend Shift',
  shiftHeader: {
    day: 'Day',
    startTime: 'Start Time',
    endTime: 'End Time',
    minimumHours: 'Minimum Hours',
  },
  flexibilityRequirements: 'Flexibility Requirements',
  flexibilityOutOf: '(Out of 5 weekdays and 2 weekends)',
  requirementType: 'Requirement',
  weekday: 'Weekday',
  weekend: 'Weekend',
  totalRequiredStartTimes: 'The total number of required start times.',
  totalRequiredEndTimes: 'The total number of required end times.',
  mandatoryDays: 'Mandatory Days',
  comparison: 'Comparison',
  desiredAvailabilityWithMinHours: 'Desired Availability with Minimum Hours',
  candidateDoesNotMeetAvailability: 'The candidate does not meet the availability requirements for this position.',
};
